// src/pages/solusi/SmartFarming.jsx
import React, { useEffect, useState } from 'react'; // Import useState untuk notifikasi
import { Link } from 'react-router-dom';
import ProductCard from '../../components/Marketplace/ProductCard'; // Pastikan path ini benar

// Data produk dummy terkait Smart Farming
const smartFarmingProducts = [
  { id: 'sensor-tanah', nama: 'Sensor Kelembaban Tanah Capacitive', harga: 18000, image: '/images/smart-farming/sensor-tanah.webp', penjual: 'AgroSensor', description: 'Memonitor tingkat kelembaban tanah untuk irigasi presisi.', discount: 0, stock: 150, category: 'Sensor' },
  { id: 'yf-s201', nama: 'Sensor Aliran Air YF-S201', harga: 32000, image: '/images/smart-farming/sensor-air.webp', penjual: 'HidroTek', description: 'Mengukur volume aliran air dalam sistem irigasi.', discount: 0, stock: 80, category: 'Sensor' },
  { id: 'esp32-devkit', nama: 'ESP32 DevKit C V4 (WiFi & BLE)', harga: 65000, image: '/images/smart-farming/esp32-devkit.webp', penjual: 'Toko IoT Utama', description: 'Mikrokontroler serbaguna untuk membangun sistem pertanian cerdas.', discount: 5, stock: 100, category: 'Mikrokontroler' },
  { id: 'smart-relay-module', nama: 'Modul Relay Cerdas 2 Channel 12V', harga: 30000, image: '/images/smart-farming/smart-relay.webp', penjual: 'Elektronik Maju', description: 'Mengontrol pompa air atau perangkat listrik lainnya secara otomatis.', discount: 0, stock: 70, category: 'Modul & Komponen' },
  { id: 'sensor-ph-tanah', nama: 'Sensor pH Tanah Akurat', harga: 45000, image: '/images/smart-farming/sensor-ph.webp', penjual: 'AgroSensor', description: 'Mengukur tingkat keasaman tanah untuk optimasi nutrisi.', discount: 0, stock: 60, category: 'Sensor' },
  { id: 'lampu-grow-led', nama: 'Lampu Grow LED Full Spectrum 50W', harga: 150000, image: '/images/smart-farming/grow-light.webp', penjual: 'UrbanFarm Tech', description: 'Mendukung pertumbuhan tanaman dalam lingkungan terkontrol.', discount: 10, stock: 40, category: 'Aksesoris' },
];

const SmartFarming = ({ setKeranjang }) => {
  const [notification, setNotification] = useState({ message: '', type: '' }); // State untuk notifikasi

  useEffect(() => {
    // --- SEO Meta Tags untuk Halaman Smart Farming ---
    document.title = "Smart Farming: Pertanian Modern dengan IoT | Solusi IoT Cerdas";

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "Tingkatkan produktivitas, efisiensi sumber daya, dan keberlanjutan pertanian Anda dengan solusi Smart Farming berbasis IoT. Pantau kelembaban tanah, irigasi otomatis, kendali iklim mikro, dan hemat sumber daya.");

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', "smart farming, pertanian IoT, sensor tanah, irigasi otomatis, pertanian presisi, ESP32 pertanian, solusi pertanian cerdas, hidroponik IoT, agritech");

    // Open Graph Tags (untuk media sosial)
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) { ogTitle = document.createElement('meta'); ogTitle.setAttribute('property', 'og:title'); document.head.appendChild(ogTitle); }
    ogTitle.setAttribute('content', "Smart Farming: Pertanian Modern dengan IoT | Solusi IoT Cerdas");

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) { ogDescription = document.createElement('meta'); ogDescription.setAttribute('property', 'og:description'); document.head.appendChild(ogDescription); }
    ogDescription.setAttribute('content', "Tingkatkan produktivitas dan efisiensi pertanian Anda dengan solusi Smart Farming berbasis IoT. Pantau kelembaban tanah, irigasi otomatis, kendali iklim mikro, dan hemat sumber daya.");

    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) { ogType = document.createElement('meta'); ogType.setAttribute('property', 'og:type'); document.head.appendChild(ogType); }
    ogType.setAttribute('content', "website");

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) { ogUrl = document.createElement('meta'); ogUrl.setAttribute('property', 'og:url'); document.head.appendChild(ogUrl); }
    ogUrl.setAttribute('content', "https://www.solusiiotcerdas.com/solusi/smart-farming"); // Ganti dengan URL domain Anda untuk halaman ini

    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) { ogImage = document.createElement('meta'); ogImage.setAttribute('property', 'og:image'); document.head.appendChild(ogImage); }
    ogImage.setAttribute('content', "https://www.solusiiotcerdas.com/images/smart-farming/hero-smart-farming.webp"); // Ganti dengan URL gambar relevan untuk Smart Farming

    // Twitter Card Tags
    let twitterCard = document.querySelector('meta[name="twitter:card"]');
    if (!twitterCard) { twitterCard = document.createElement('meta'); twitterCard.setAttribute('name', 'twitter:card'); document.head.appendChild(twitterCard); }
    twitterCard.setAttribute('content', "summary_large_image");

    let twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (!twitterImage) { twitterImage = document.createElement('meta'); twitterImage.setAttribute('name', 'twitter:image'); document.head.appendChild(twitterImage); }
    twitterImage.setAttribute('content', "https://www.solusiiotcerdas.com/images/smart-farming/hero-smart-farming.webp"); // Ganti dengan URL gambar relevan untuk Smart Farming

    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.setAttribute('href', "https://www.solusiiotcerdas.id/solusi/smart-farming"); // Ganti dengan URL halaman sebenarnya

    return () => {
      // Cleanup opsional
    };
  }, []);

  const handleAddToCart = (productToAdd) => {
    if (typeof setKeranjang === 'function') {
      setKeranjang(prev => {
        const existingItem = prev.find(item => item.id === productToAdd.id);
        if (existingItem) {
          return prev.map(item =>
            item.id === productToAdd.id ? { ...item, jumlah: item.jumlah + 1 } : item
          );
        } else {
          return [...prev, { ...productToAdd, jumlah: 1 }];
        }
      });
      setNotification({ message: `${productToAdd.nama} berhasil ditambahkan ke keranjang!`, type: 'success' });
      setTimeout(() => setNotification({ message: '', type: '' }), 3000);
    } else {
      console.error('Error: setKeranjang bukan fungsi di handleAddToCart.');
      setNotification({ message: `Gagal menambahkan ${productToAdd.nama} ke keranjang. (setKeranjang error)`, type: 'error' });
      setTimeout(() => setNotification({ message: '', type: '' }), 3000);
    }
  };

  return (
    <div className="bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200 min-h-screen py-16 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Notifikasi (misal: "Barang ditambahkan ke keranjang") */}
        {notification.message && (
          <div className={`fixed top-4 right-4 p-4 rounded-lg shadow-xl text-white z-50
                          ${notification.type === 'success' ? 'bg-green-500' : 'bg-red-500'}
                          animate-fade-in-down`}>
            {notification.message}
          </div>
        )}

        {/* 1. Hero Section */}
        <section className="text-center mb-16 relative overflow-hidden rounded-xl shadow-lg"
                 style={{ backgroundImage: 'url(/images/smart-farming/hero-smart-farming.webp)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-70"></div>
          <div className="relative z-10 p-8 md:p-12 text-white">
            <h1 className="text-4xl md:text-6xl font-extrabold leading-tight mb-4 animate-fade-in-up">
              Smart Farming: Revolusi Pertanian dengan IoT
            </h1>
            <p className="text-lg md:text-2xl max-w-4xl mx-auto mb-8 animate-fade-in delay-200">
              Ubah cara Anda bertani. Dengan solusi Smart Farming berbasis IoT dari Solusi IoT Cerdas, maksimalkan hasil panen, efisienkan sumber daya, dan miliki kendali penuh atas lahan Anda, dari mana saja.
            </p>
            <Link to="/solusi/konsultasi" className="inline-block bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-full text-xl shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 animate-bounce-once delay-500">
              Dapatkan Konsultasi Gratis
            </Link>
          </div>
        </section>

        {/* 2. Mengapa Smart Farming Penting? */}
        <section className="mb-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">Mengapa Smart Farming Adalah Masa Depan Pertanian?</h2>
          <p className="text-lg text-gray-700 dark:text-gray-300 text-center max-w-3xl mx-auto mb-10">
            Pertanian modern menghadapi tantangan besar: perubahan iklim, kelangkaan air, dan kebutuhan pangan yang terus meningkat. Smart Farming menawarkan solusi inovatif untuk mengatasi ini.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex flex-col items-center text-center p-4 bg-gray-50 dark:bg-gray-700 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1">
              <div className="text-5xl text-green-500 dark:text-green-300 mb-4">📈</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Peningkatan Hasil Panen & Kualitas</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm">
                Optimalkan setiap faktor pertumbuhan tanaman secara presisi untuk hasil yang melimpah dan kualitas premium.
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4 bg-gray-50 dark:bg-gray-700 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1">
              <div className="text-5xl text-blue-500 dark:text-blue-300 mb-4">💰</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Efisiensi Biaya & Sumber Daya</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm">
                Minimalkan pemborosan air, pupuk, pestisida, dan energi melalui aplikasi yang terukur dan otomatis.
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4 bg-gray-50 dark:bg-gray-700 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1">
              <div className="text-5xl text-yellow-500 dark:text-yellow-300 mb-4">🔬</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Pengambilan Keputusan Cerdas</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm">
                Akses data real-time dan analisis mendalam untuk keputusan pertanian yang lebih tepat dan proaktif.
              </p>
            </div>
          </div>
        </section>

        {/* 3. Fitur-Fitur Unggulan Solusi Smart Farming */}
        <section className="mb-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">Fitur Unggulan Solusi Smart Farming Kami</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div className="order-2 md:order-1 text-gray-700 dark:text-gray-300">
              <ul className="list-none space-y-4">
                <li className="flex items-start gap-3">
                  <span className="text-green-500 text-2xl mt-1 flex-shrink-0">🌱</span>
                  <div>
                    <strong className="text-gray-900 dark:text-gray-100 text-xl block">Pemantauan Lingkungan Lahan Presisi</strong>
                    <p className="text-sm">Sensor kelembaban tanah, pH, NPK, dan suhu tanah memberikan gambaran akurat kondisi lahan secara real-time.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-blue-500 text-2xl mt-1 flex-shrink-0">💧</span>
                  <div>
                    <strong className="text-gray-900 dark:text-gray-100 text-xl block">Sistem Irigasi Otomatis Adaptif</strong>
                    <p className="text-sm">Pompa air aktif berdasarkan data sensor tanah dan prakiraan cuaca, menghemat air dan menghindari penyiraman berlebihan.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-yellow-500 text-2xl mt-1 flex-shrink-0">🌤️</span>
                  <div>
                    <strong className="text-gray-900 dark:text-gray-100 text-xl block">Kendali Iklim Mikro & Proteksi Tanaman</strong>
                    <p className="text-sm">Pemantauan suhu, kelembaban udara, dan cahaya. Sistem dapat mengaktifkan kipas atau pelindung otomatis.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-purple-500 text-2xl mt-1 flex-shrink-0">🧪</span>
                  <div>
                    <strong className="text-gray-900 dark:text-gray-100 text-xl block">Fertigasi & Nutrisi Otomatis</strong>
                    <p className="text-sm">Pemberian pupuk cair (fertigasi) dan penyesuaian pH air/tanah secara otomatis sesuai kebutuhan tanaman.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-red-500 text-2xl mt-1 flex-shrink-0">🐞</span>
                  <div>
                    <strong className="text-gray-900 dark:text-gray-100 text-xl block">Deteksi Dini Hama & Penyakit</strong>
                    <p className="text-sm">Sistem dapat mendeteksi anomali kondisi tanaman atau lingkungan yang mengindikasikan potensi serangan hama/penyakit.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 text-2xl mt-1 flex-shrink-0">📊</span>
                  <div>
                    <strong className="text-gray-900 dark:text-gray-100 text-xl block">Dashboard Analitik & Pelaporan Komprehensif</strong>
                    <p className="text-sm">Visualisasi data pertumbuhan, konsumsi sumber daya, dan laporan kesehatan lahan untuk pengambilan keputusan strategis.</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="order-1 md:order-2 flex justify-center">
              <img
                src="/images/smart-farming/smart-farming-features.webp"
                alt="Smart Farming System Features"
                className="rounded-lg shadow-xl w-full h-auto max-w-md transition-transform duration-500 transform hover:scale-105"
              />
            </div>
          </div>
        </section>

        {/* 4. Implementasi Smart Farming */}
        <section className="mb-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">Bagaimana Solusi Smart Farming Diterapkan?</h2>
          <div className="flex flex-col md:flex-row items-center justify-center gap-8">
            <div className="md:w-1/2">
              <img src="/images/smart-farming/implementation-diagram.webp" alt="Smart Farming Implementation Diagram" className="rounded-lg shadow-xl w-full h-auto" />
            </div>
            <div className="md:w-1/2 space-y-6 text-gray-700 dark:text-gray-300">
              <p className="text-lg leading-relaxed">
                Implementasi Smart Farming Solusi IoT Cerdas dirancang agar mudah dan skalabel, cocok untuk berbagai jenis pertanian, mulai dari skala kecil hingga komersial.
              </p>
              <ul className="list-none space-y-4">
                <li className="flex items-start gap-3">
                  <span className="text-blue-600 text-2xl font-bold flex-shrink-0">1.</span>
                  <div>
                    <strong className="text-gray-900 dark:text-gray-100 block">Pemasangan Sensor di Lahan:</strong> Sensor ditempatkan di titik-titik strategis untuk mengumpulkan data kelembaban, pH, suhu, dan nutrisi tanah.
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-600 text-2xl font-bold flex-shrink-0">2.</span>
                  <div>
                    <strong className="text-gray-900 dark:text-gray-100 block">Integrasi Hardware & Mikrokontroler:</strong> Sensor dihubungkan ke mikrokontroler (ESP32/ESP8266) yang bertugas membaca data dan mengirimkannya.
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-yellow-600 text-2xl font-bold flex-shrink-0">3.</span>
                  <div>
                    <strong className="text-gray-900 dark:text-gray-100 block">Konektivitas ke Cloud:</strong> Data dikirimkan secara nirkabel (WiFi, LoRa, Cellular) ke platform cloud Solusi IoT Cerdas.
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-purple-600 text-2xl font-bold flex-shrink-0">4.</span>
                  <div>
                    <strong className="text-gray-900 dark:text-gray-100 block">Analisis Data & Automasi:</strong> Platform menganalisis data, memberikan rekomendasi, dan mengaktifkan aktuator seperti pompa irigasi secara otomatis.
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-red-600 text-2xl font-bold flex-shrink-0">5.</span>
                  <div>
                    <strong className="text-gray-900 dark:text-gray-100 block">Akses Dashboard & Notifikasi:</strong> Petani dapat memantau semua data dan mengelola sistem melalui dashboard web atau aplikasi mobile, serta menerima notifikasi penting.
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* 5. Produk Terkait (Menggunakan ProductCard) */}
        <section className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">Produk & Solusi Terkait untuk Smart Farming</h2>
          <p className="text-lg text-gray-700 dark:text-gray-300 text-center max-w-3xl mx-auto mb-10">
            Untuk memulai proyek Smart Farming Anda, berikut adalah beberapa produk esensial yang kami rekomendasikan dan tawarkan:
          </p>
          {smartFarmingProducts.length === 0 ? (
            <p className="text-center text-lg py-5 bg-white dark:bg-gray-800 rounded-lg shadow-md">Belum ada produk terkait Smart Farming yang ditampilkan.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {smartFarmingProducts.map(product => (
                <ProductCard key={product.id} product={product} onAddToCart={handleAddToCart} />
              ))}
            </div>
          )}
          {smartFarmingProducts.length > 0 && (
            <div className="text-center mt-8">
              <Link to="/toko" className="inline-block bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 transition">
                Lihat Semua Produk di Toko Kami
              </Link>
            </div>
          )}
        </section>

        {/* 6. CTA Section */}
        <section className="text-center mt-16 bg-gradient-to-r from-green-600 to-teal-700 text-white p-8 rounded-lg shadow-lg">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Siap untuk Pertanian yang Lebih Produktif & Berkelanjutan?</h2>
          <p className="text-lg md:text-xl mb-6 max-w-3xl mx-auto">
            Jangan biarkan potensi lahan Anda terbuang. Hubungi Solusi IoT Cerdas hari ini untuk menemukan bagaimana Smart Farming dapat merevolusi pertanian Anda.
          </p>
          <Link to="/solusi/konsultasi">
            <button className="bg-white text-green-600 dark:bg-green-200 dark:text-green-900 font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50">
              Jadwalkan Konsultasi Gratis
            </button>
          </Link>
        </section>

        {/* 7. Video Penjelasan/Demo Smart Farming */}
        <section className="my-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">▶️ Video Demo & Penjelasan Smart Farming</h2>
          <div className="aspect-w-16 aspect-h-9 w-full max-w-2xl mx-auto rounded-lg overflow-hidden shadow-xl">
            {/* GANTI URL INI dengan URL embed YouTube video demo Smart Farming Anda */}
            <iframe
              src="https://www.youtube.com/embed/your-smart-farming-video-id" // Contoh URL, GANTI DENGAN ID VIDEO ASLI ANDA
              title="Video Demo Sistem Smart Farming"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-world"
              allowFullScreen
              className="w-full h-full"
            ></iframe>
          </div>
          <p className="text-center text-gray-600 dark:text-gray-300 mt-4">Saksikan bagaimana teknologi kami meningkatkan hasil pertanian Anda secara nyata.</p>
        </section>

        {/* 8. Tampilan Aplikasi Smart Farming */}
        <section className="my-16 text-center bg-gray-50 dark:bg-gray-950 p-8 rounded-lg shadow-md transition-colors duration-300">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 mb-8">📲 Tampilan Aplikasi / Dashboard Smart Farming</h2>
          <p className="text-lg text-gray-700 dark:text-gray-300 mb-6">Pantau kondisi lahan, tanaman, dan kendalikan sistem irigasi dari mana saja, kapan saja, melalui antarmuka yang intuitif.</p>
          <div className="flex justify-center items-center">
            {/* GANTI GAMBAR INI dengan screenshot aplikasi/dashboard Smart Farming Anda */}
            <img
              src="/images/smart-farming/smartfarming-app-screenshot.webp" // Contoh path gambar, sesuaikan jika berbeda
              alt="Screenshot Aplikasi Smart Farming"
              className="mx-auto rounded-lg shadow-xl w-full max-w-xl h-auto"
            />
          </div>
          <p className="text-center text-gray-600 dark:text-gray-300 mt-4">Antarmuka visual yang memudahkan pemantauan dan pengambilan keputusan cerdas di ujung jari Anda.</p>
        </section>

        {/* 9. Peta Lokasi Kami (Opsional, jika relevan untuk Smart Farming) */}
        {/* Anda bisa mengaktifkan bagian ini jika merasa peta lokasi relevan di sini.
            Pastikan URL src iframe diisi dengan URL embed Google Maps yang benar. */}
        {/* <section className="my-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">📍 Lokasi Kami di Depok, Jawa Barat</h2>
          <div className="aspect-w-16 aspect-h-9 w-full max-w-2xl mx-auto rounded-lg overflow-hidden shadow-xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.250567780004!2d106.82025217498064!3d-6.36399999362744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTPCsDQwJzUxLjUiUyAxMDbCsDQ5JzIzLjgiRT!5e0!3m2!1sen!2sid!4v1687654321098!5m2!1sen!2sid" // Ganti dengan URL Maps Anda
              title="Lokasi Kantor Solusi IoT Cerdas di Depok"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full"
            ></iframe>
          </div>
          <p className="text-center text-gray-600 dark:text-gray-300 mt-4">Kunjungi kami atau hubungi kami untuk informasi lebih lanjut.</p>
        </section> */}

      </div>
    </div>
  );
};

export default SmartFarming;